import { _ as _defineProperty } from '../defineProperty-2d1aa32d.js';
import HttpService from '@picsart/rc/services/http';
import getDeviceId from '@picsart/rc/getDeviceId';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var extendHeaders = function extendHeaders(options) {
  return _objectSpread(_objectSpread({}, options), {}, {
    headers: _objectSpread(_objectSpread({}, options.headers), getDeviceId() && {
      deviceid: getDeviceId()
    })
  });
};
var get = function get(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return HttpService.get(url, extendHeaders(options));
};
var post = function post(url, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return HttpService.post(url, data, extendHeaders(options));
};
var put = function put(url, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return HttpService.put(url, data, extendHeaders(options));
};
var httpDelete = function httpDelete(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return HttpService["delete"](url, undefined, extendHeaders(options));
};
var patch = function patch(url, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var reqOptions = HttpService.getOptions(_objectSpread(_objectSpread({}, extendHeaders(options)), {}, {
    method: 'PATCH',
    body: HttpService.getFormData(data)
  }));
  return HttpService.fetch(url, reqOptions);
};
var getApiUrl = function getApiUrl() {
  return HttpService.config.apiUrl;
};
var httpService = {
  get: get,
  post: post,
  put: put,
  patch: patch,
  getApiUrl: getApiUrl
};

export { httpService as default, get, getApiUrl, httpDelete, patch, post, put };
//# sourceMappingURL=index.js.map
